import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import Layout from "../components/layout";
import { useUser } from "../config/userProvider";
import { Link, useNavigate } from "react-router-dom";
import { InfiLoader } from "../components/loader";
import { IoAddOutline } from "react-icons/io5";
import SearchContainer from "../components/searchContainer";
import { PopModel } from "../components/popupModels";
import BackHeader from "../components/backHeader";
import Card from "../components/card";
import Pagination from "../components/pagination";
import { toast } from "react-toastify";
import DataNotFound from "../components/dataNotFound";
// import ImageMagnifier from "../components/imageMagnifier";
// import  { Container } from "../components/layout";
// import Advanceloader from "../advanceloader.gif";
// import { VariantSku } from "./createCatalog/index";
// import { IoIosAdd } from "react-icons/io";
// import { LuEye } from "react-icons/lu";
// import { LuPenLine } from "react-icons/lu";
// import { FiSearch } from "react-icons/fi";
// import { MdOutlineAddBox } from "react-icons/md";
// import { IoMdAddCircle } from "react-icons/io";
// import ButtonContainer from "../components/buttonContainer";

const Products = () => {
  const { userData } = useUser();
  const navigate = useNavigate();
  let vendorObjId = userData?.vendorDetails?.vendorObjId;
  console.log("userData", userData);
  console.log("vendorObjId 16 ", vendorObjId);

  const [loading, setLoading] = useState(false);
  const [deleteProductsLoading, setDeleteProductsLoading] = useState(false);
  // const [syncStatus, setSyncStatus] = useState(null);
  const [data, setData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [showImportContainer, setShowImportContainer] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");

  // ========================PAGINATION============================
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState("");
  // ====================================================

  // const syncProductTarget = () => {
  //   setLoading(true);
  //   axios
  //     .get(`${apiurl}/sync`)
  //     .then((response) => {
  //       if (response.data.success === true) {
  //         setSyncStatus("success");
  //       } else {
  //         setSyncStatus("error");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error syncing products:", error);
  //       setSyncStatus("error");
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // const AllProductsList = async () => {
  //   setLoading(true);
  //   let data = {
  //     vendorObjId: vendorObjId,
  //   };
  //   try {
  //     const response = await axios.post(
  //       `${apiurl}/admin/v1/product/get`,
  //       data,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     console.log("response && response.data", response && response);
  //     if (response && response?.data) {
  //       setData(response?.data?.products);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user list:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const fetchProductsList = () => {
  //   setLoading(true);
  //   let data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //     page: currentPage,
  //     limit: JSON.parse(itemsPerPage),
  //   });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/product/get`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify(response.data));
  //       if (response && response?.data) {
  //         setData(response?.data?.products);
  //         setPaginationData(response?.data?.pagination);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {
  //   fetchProductsList();
  // }, [currentPage, itemsPerPage]);

  const fetchProductsList = useCallback(() => {
    setLoading(true);

    const data = JSON.stringify({
      vendorObjId: vendorObjId,
      page: currentPage,
      limit: JSON.parse(itemsPerPage),
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/product/get`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        if (response?.data) {
          setData(response.data.products);
          setPaginationData(response.data.pagination);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [vendorObjId, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchProductsList();
  }, [fetchProductsList]);

  console.log("data", data);

  // const filterdata =
  //   data &&
  //   data.filter((product) =>
  //     product.title.toLowerCase().includes(searchInput.toLowerCase())
  //   );

  const filterdata =
    data &&
    data.filter((product) => {
      const matchesSearch = product.title
        .toLowerCase()
        .includes(searchInput.toLowerCase());

      const matchesStatus =
        statusFilter === "All" ||
        product.status.toLowerCase() === statusFilter.toLowerCase();

      return matchesSearch && matchesStatus;
    });

  const [deleteProductIds, setDeleteProductIds] = useState([]);

  const AllCheckedHandler = () => {
    if (filterdata.length !== deleteProductIds.length) {
      filterdata.forEach((item) =>
        setDeleteProductIds((prev) => [...prev, item._id]),
      );
    } else {
      setDeleteProductIds([]);
    }
  };

  const CheckedHandler = (id) => {
    const contain = deleteProductIds.includes(id);
    if (contain) {
      setDeleteProductIds(deleteProductIds.filter((i) => i !== id));
    } else {
      setDeleteProductIds((prev) => [...prev, id]);
    }
  };
  const [isDeleted, WantToDelete] = useState(false);

  const DeleteHandler = () => {
    setDeleteProductsLoading(true);
    let data = JSON.stringify({
      productObjIds: deleteProductIds,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/product/delete`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response?.data?.success) {
          WantToDelete(false);
          toast.success(
            response?.data?.message
              ? response?.data?.message
              : "Products deleted successfully",
          );
          fetchProductsList();
          setDeleteProductsLoading(false);
          setDeleteProductIds([]);
        } else {
          setDeleteProductsLoading(false);
          toast.error(
            response?.data?.message
              ? response?.data?.message
              : "Failed to delete products",
          );
        }
      })
      .catch((error) => {
        console.log(error);
        setDeleteProductsLoading(false);
      });
  };

  // =================== PAGINATION =================

  // Calculate the current items to display
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Layout>
      {isDeleted && (
        <Card.Confirmation
          message="Are you sure?"
          onConfirm={() => DeleteHandler()}
          onClose={() => WantToDelete(false)}
          loading={deleteProductsLoading}
          loadingTitle="Deleting..."
        />
      )}

      {loading === true ? (
        <InfiLoader maintext="Fetching Products Data.." />
      ) : (
        <div className="border bg-white border-slate-200 sm:rounded-lg md:rounded-xl h-full w-full px-2 py-2">
          <div className=" relative flex flex-col gap-2 w-full overflow-hidden rounded-lg sm:rounded-xl px-2 h-full p-2">
            <BackHeader
              title={
                <span className="flex flex-col md:flex-row md:gap-4 items-center">
                  Products
                  <span className="hidden lg:flex">
                    {" "}
                    - {paginationData?.totalItems}
                  </span>
                  <select
                    value={itemsPerPage}
                    className="text-xs rounded-md md:rounded-lg hidden border px-2 md:py-1 md:px-2"
                    onChange={(e) => setItemsPerPage(e.target.value)}
                  >
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                  {/* <div className="flex gap-4 text-xs"> */}
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="hidden md:block border px-2 py-1 rounded-lg text-xs outline-none"
                  >
                    <option value="All">All</option>
                    <option value="Draft">Draft</option>
                    <option value="Active">Active</option>
                  </select>
                  {/* </div> */}
                </span>
              }
              rightSide={
                <div className="flex gap-3 md:mx-3 items-center">
                  {deleteProductIds.length > 0 &&
                    userData?.userType === "superadmin" && (
                      <button
                        onClick={() => WantToDelete(true)}
                        className="bg-red-50 hover:bg-[#c00218] border border-red-300 text-[#c00218] hover:text-white rounded-lg text-xs md:text-base py-1 px-2 md:py-2 md:px-3"
                      >
                        Delete
                      </button>
                    )}
                  <button
                    className="border text-xs md:text-sm  lg:text-base py-1 px-2 md:px-3 md:py-2 rounded-md border-zinc-900 hover:bg-zinc-900  hover:text-white"
                    onClick={() => setShowImportContainer(true)}
                  >
                    Import
                  </button>

                  <Link
                    to="/products/add"
                    className="flex justify-center  items-center px-2 md:px-4 md:py-2 border  border-zinc-900 hover:bg-zinc-900  hover:text-white rounded-md"
                  >
                    <button className="flex gap-1 items-center">
                      <span className="text-sm md:text-xl p-1.5 sm:p-0">
                        <IoAddOutline />
                      </span>
                      <span className="hidden lg:block">Add</span>
                    </button>
                  </Link>
                  <div className="hidden md:flex md:gap-2 items-center w-[100%]">
                    <SearchContainer
                      placeholder={"Search Products..."}
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      className="w-full"
                    />
                  </div>
                </div>
              }
            />
            {/* <div className="flex flex-col md:flex-row justify-between items-center md:m-2 md:p-2 gap-2 md:gap-0">
              <div className="flex justify-between w-[100%] items-center">
                <div>
                  <h1 className="text-2xl md:text-3xl font-medium text-center md:mb-3 text-slate-500">
                    Products
                  </h1>
                </div>
                <div className="flex gap-3 mx-3 items-center">
                  {deleteProductIds.length > 0 &&
                    userData?.userType === "superadmin" && (
                      <button
                        onClick={() => WantToDelete(true)}
                        className="bg-red-50 hover:bg-[#c00218] border border-red-300 text-[#c00218] hover:text-white rounded-lg p-2 px-3 "
                      >
                        Delete
                      </button>
                    )}
                  <button
                    className="border text-xs  sm:text-base p-2 px-3 rounded-md border-zinc-900 hover:bg-zinc-900  hover:text-white"
                    onClick={() => setShowImportContainer(true)}
                  >
                    Import
                  </button>

                  <Link
                    to="/products/add"
                    className="flex justify-center  items-center px-2 md:px-4 md:py-2 border  border-zinc-900 hover:bg-zinc-900  hover:text-white rounded-md"
                  >
                    <button className="flex gap-1 items-center">
                      <span className="text-xl p-1.5 sm:p-0">
                        <IoAddOutline />
                      </span>
                      <span className="hidden md:block">Add</span>
                    </button>
                  </Link>
                </div>
              </div>
              <div className="flex md:gap-2 items-center w-[100%] md:w-[40%]">
                <SearchContainer
                  placeholder={"Search Products..."}
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
              </div>
            </div> */}

            <div className="relative overflow-y-auto h-full sm:rounded-lg">
              {filterdata && filterdata.length > 0 ? (
                <table className="w-full text-sm text-left text-gray-500">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0">
                    <tr>
                      <th scope="col" class="p-4">
                        <div class="flex items-center">
                          <input
                            id="checkbox-all-search"
                            type="checkbox"
                            checked={
                              filterdata.length === deleteProductIds.length
                            }
                            onClick={AllCheckedHandler}
                            class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 "
                          />
                          <label for="checkbox-all-search" class="sr-only">
                            checkbox
                          </label>
                        </div>
                      </th>
                      <th scope="col" className="pl-4 sm:pl-6 py-3">
                        S. No.
                      </th>
                      <th scope="col" className="pr-3">
                        Image
                      </th>
                      <th scope="col" className="pl-4 sm:pl-6 py-3">
                        Title
                      </th>
                      <th scope="col" className="pl-4 sm:pl-6 py-3">
                        Status
                      </th>
                      <th scope="col" className="pl-4 sm:pl-6 py-3">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterdata &&
                      filterdata.length > 0 &&
                      filterdata.map((item, index) => (
                        <tr
                          key={item.id}
                          className={`${
                            index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          } border-b cursor-pointer h-10`}
                        >
                          {" "}
                          <td class="w-4 p-4">
                            <div class="flex items-center">
                              <input
                                id="checkbox-table-search-1"
                                type="checkbox"
                                checked={deleteProductIds.includes(item._id)}
                                onClick={() => CheckedHandler(item._id)}
                                class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500   focus:ring-2 "
                              />
                              <label
                                for="checkbox-table-search-1"
                                class="sr-only"
                              >
                                checkbox
                              </label>
                            </div>
                          </td>
                          <th
                            scope="row"
                            className="pl-4 sm:pl-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                          >
                            {index + 1}
                          </th>
                          <td className="py-2">
                            <label
                              htmlFor={`${item.id}`}
                              className="cursor-pointer"
                            >
                              <img
                                src={item.image ?? "/imageNotFound.png"}
                                alt=""
                                className="h-11 w-11 object-cover rounded"
                              />
                              {/* <ImageMagnifier
                                src={item.image || "/imageNotFound.png"}
                                alt={item.title}
                                width={44}
                                height={44}
                                zoom={3}
                                magnifierSize={300}
                              /> */}
                            </label>
                          </td>
                          <td className="pl-4 sm:pl-6 py-4">
                            <label
                              htmlFor={`${item.id}`}
                              className="cursor-pointer"
                            >
                              {item.title}
                            </label>
                          </td>
                          <td className="pl-4 sm:pl-6 py-4">{`${item.status}`}</td>
                          <td
                            className="pl-4 sm:pl-6 py-4 text-blue-500 hover:font-semibold"
                            onClick={() => navigate(`/products/${item?._id}`)}
                          >
                            view
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <DataNotFound.Page label="Product" />
              )}
            </div>

            <Pagination
              currentPage={currentPage}
              totalItems={paginationData?.totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      )}

      {showImportContainer && (
        <PopModel setShowImportContainer={setShowImportContainer}></PopModel>
      )}
    </Layout>
  );
};

export default Products;
// };
